export default __webpack_public_path__ + "static/media/Up.4ae18d05.svg";